// UserMessageInfo.js
import React from 'react';
import "../../chat/animate/slide_top.css"
import "../../chat/animate/slide_in_right.css";
import './userInfo.scss'
import arrow_right from '../../../assets/update_new/arrow_right.svg';

import aries from '../../../assets/update_new/aries.svg'
import taurus from '../../../assets/update_new/taurus.svg'
import gemini from '../../../assets/update_new/gemini.svg'
import cancer from '../../../assets/update_new/cancer.svg'
import leo from '../../../assets/update_new/leo.svg'
import virgo from '../../../assets/update_new/virgo.svg'
import libra from '../../../assets/update_new/libra.svg'
import scorpio from '../../../assets/update_new/scorpio.svg'
import sagittarius from '../../../assets/update_new/sagittarius.svg'
import capricorn from '../../../assets/update_new/capricorn.svg'
import aquarius from '../../../assets/update_new/aquarius.svg'
import pisces from '../../../assets/update_new/pisces.svg'

const zodiacSigns = [
    { name: 'Taurus', image: taurus },
    { name: 'Aries', image: aries },
    { name: 'Gemini', image: gemini },
    { name: 'Libra', image: libra },
    { name: 'Leo', image: leo },
    { name: 'Virgo', image: virgo },
    { name: 'Cancer', image: cancer },
    { name: 'Scorpio', image: scorpio },
    { name: 'Capricorn', image: capricorn },
    { name: 'Aquarius', image: aquarius },
    { name: 'Pisces', image: pisces },
    { name: 'Sagittarius', image: sagittarius },
];
const getZodiacSign = (dateString)=> {
    const date = new Date(dateString);
    const month = date.getMonth() + 1; // 月份从0开始
    const day = date.getDate();
    if ((month === 3 && day >= 21) || (month === 4 && day <= 19)) {
        return 'Aries';
    } else if ((month === 4 && day >= 20) || (month === 5 && day <= 20)) {
        return 'Taurus';
    } else if ((month === 5 && day >= 21) || (month === 6 && day <= 20)) {
        return 'Gemini';
    } else if ((month === 6 && day >= 21) || (month === 7 && day <= 22)) {
        return 'Cancer';
    } else if ((month === 7 && day >= 23) || (month === 8 && day <= 22)) {
        return 'Leo';
    } else if ((month === 8 && day >= 23) || (month === 9 && day <= 22)) {
        return 'Virgo';
    } else if ((month === 9 && day >= 23) || (month === 10 && day <= 22)) {
        return 'Libra';
    } else if ((month === 10 && day >= 23) || (month === 11 && day <= 21)) {
        return 'Scorpio';
    } else if ((month === 11 && day >= 22) || (month === 12 && day <= 21)) {
        return 'Sagittarius';
    } else if ((month === 12 && day >= 22) || (month === 1 && day <= 19)) {
        return 'Capricorn';
    } else if ((month === 1 && day >= 20) || (month === 2 && day <= 18)) {
        return 'Aquarius';
    } else if ((month === 2 && day >= 19) || (month === 3 && day <= 20)) {
        return 'Pisces';
    }
    return '';
}
const UserInfo = ({ gender, birthday, bloodType }) => {
    return (
        <div className="user_content slide-in-right">
            <div className="user_info_div">
                <div className="user_info_information">
                    {birthday != "" &&
                        <div className="user_info_sign">
                            <img src={zodiacSigns.find(sign => sign.name === getZodiacSign(birthday)).image}></img>
                            <span style={{ marginLeft: '5px' }}>{getZodiacSign(birthday)}</span>
                        </div>
                    }

                    <span>{gender}~ {bloodType} ~{birthday}</span>
                </div>
            </div>
        </div>
    );
}

export default UserInfo;
